import React from 'react';
import { motion } from 'framer-motion';
import { DownloadIcon, LogOutIcon } from 'lucide-react';
import { ContactSection } from './ContactSection';
interface PresentationViewProps {
  onLogout: () => void;
}
export function PresentationView({
  onLogout
}: PresentationViewProps) {
  return <div className="bg-obsidian flex flex-col" data-id="element-49">
      {/* Header */}
      <header className="w-full px-6 py-8 flex justify-between items-center z-10" data-id="element-50">
        <h1 className="text-xl md:text-2xl tracking-widest text-offwhite/90 uppercase text-glow" data-id="element-51">
          The Doors of Perception Private Access
        </h1>
        <button onClick={onLogout} className="text-muted hover:text-offwhite transition-colors duration-500 flex items-center gap-2 text-sm uppercase tracking-widest" data-id="element-52">
          <span className="hidden md:inline" data-id="element-53">Exit Preview</span>
          <LogOutIcon className="w-4 h-4" data-id="element-54" />
        </button>
      </header>

      {/* Main Content */}
      <main className="flex-1 flex flex-col items-center w-full" data-id="element-55">
        <div className="w-full max-w-7xl mx-auto px-4 md:px-8 mb-12" data-id="element-56">
          <div className="w-full h-[70vh] md:h-[80vh] bg-charcoal rounded-sm border border-borderline overflow-hidden box-glow relative" data-id="element-57">
            <iframe src="https://project-doors-of-perception-deck.magicpatterns.app/" className="w-full h-full border-0" title="The Doors of Perception - Slide Deck" data-id="element-58" />
          </div>
        </div>

        {/* Download Action */}
        <div className="mb-24" data-id="element-59">
          <a href="https://drive.google.com/uc?export=download&id=1S9ft2MYPM-YUdyEQeL9d-HbWFJg_zI7J" target="_blank" rel="noopener noreferrer" className="group flex items-center gap-3 px-8 py-4 border border-borderline bg-charcoal/50 hover:bg-charcoal hover:border-muted/50 transition-all duration-500 rounded-sm box-glow-hover" data-id="element-60">
            <DownloadIcon className="w-5 h-5 text-muted group-hover:text-offwhite transition-colors duration-500" data-id="element-61" />
            <span className="uppercase tracking-widest text-sm text-offwhite/80 group-hover:text-offwhite transition-colors duration-500" data-id="element-62">
              Download Full Presentation (PDF)
            </span>
          </a>
        </div>

        <ContactSection data-id="element-63" />
      </main>
    </div>;
}